var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"text-capitalize mb-3",attrs:{"to":"/member/upload"}},[_vm._v("Upload Members")]),_c('Clean',{staticClass:"mb-3"}),_c('PopulatePhone',{staticClass:"mb-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }